import { IonInput, IonItem, IonLabel, IonNote } from "@ionic/react";
import React from "react";
import { Controller, FieldError, FieldValues, UseFormRegister } from "react-hook-form";
import { useTheme } from "react-jss";
import i18n from "../../services/i18n";
import "./inputStyle.css";
import { FormFieldStyle } from "./inputStyle.jss";
interface propsInput {
    type: "text" | "email" | "password";
    position?: "fixed" | "stacked" | "floating";
    fill?: "solid" | "outline" | null;
    name: string;
    value: string;
    label: string;
    placeHolder?: string;
    helper?: boolean;
    required?: boolean;
    control: UseFormRegister<FieldValues> & any;
    onChange: (e: any) => void;
    error?: FieldError;
    maxLength?: number;
}

interface IFormField extends propsInput {
    value: string;
    onChange: (event: any) => any;
    label: string;
}

const FormField: React.FC<IFormField> = ({ label, value, onChange, control, name, helper, placeHolder, position, required, error, maxLength }) => {
    const theme = useTheme();
    const style = FormFieldStyle({ theme });
    return (
        <div className={style.container}>
            <IonItem className={`${"container"} ${error && "ion-invalid"}`}>
                <IonLabel
                    className="label"
                    position={position ?? "floating"}
                >
                    {label}
                </IonLabel>

                <Controller
                    control={control}
                    name={name}
                    rules={{ required }}
                    render={({ field }) => {
                        return (
                            <>
                                <IonInput
                                    className={` input ion-justify-content-center ion-align-items`}
                                    placeholder={placeHolder}
                                    onInput={onChange}
                                    value={value}
                                    onIonBlur={() => field.onBlur()}
                                    onIonChange={(e) => {
                                        field.onChange(e.detail.value);
                                        onChange(e);
                                    }}
                                    maxlength={maxLength}
                                />

                                {helper && <IonNote slot="helper"></IonNote>}

                                <IonNote slot="error">{i18n.t(error?.message ?? "")}</IonNote>
                            </>
                        );
                    }}
                />
            </IonItem>
        </div>
    );
};

export default FormField;
